const COOKIE = "cookie_notification";

export const LocalStorageKeys = {
    COOKIE,
};
